import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import ReservationsState from '../../types/ReservationsState'

const getters: GetterTree<ReservationsState, RootState> = {
  getCurrentDates: state => ({from: state.dateFrom, to: state.dateTo})
}

export default getters
